export default __webpack_public_path__ + "static/media/employeedirectory.5224b6a2.png";